import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import client from '../containers/client/reducer';
import socket from '../containers/socket/reducer';
import priceBoard from '../containers/banggia/reducer';
import cash from '../containers/cash/reducer';
import summary from '../containers/summary/reducer';
import customer from '../containers/customer/reducer';
import privData from '../containers/privData/reducer';
import market from 'containers/market/reducer';

import login from '../components/modal/login/reducer';
import authen from '../components/modal/auth/reducer';
import resetPass from '../components/modal/resetPass/reducer';
import ordCond from '../components/modal/ordCond/reducer';
import stockDetail from '../components/modal/stockDetail/reducer';

const IndexReducer = combineReducers({
  login,
  authen,
  resetPass,
  ordCond,
  stockDetail,
  client,
  form,
  socket,
  priceBoard,
  cash,
  summary,
  customer,
  privData,
  market,
});

export default IndexReducer;
